export default __webpack_public_path__ + "images/VB.739ffe5.png";